<template>
  <div class="view-community container">
    <div class="row g-4">
      <div class="col-lg-3 col-sm-6 order-lg-1">
        <h2 class="mb-0 font-serif">Dúvidas</h2>

        <div class="small text-secondary mt-4">
          Este é o espaço ideal para trocar experiências e conversar com
          respeito sobre temas ligados ao inglês, intercâmbio e aprendizado
          cultural. Participe ativamente, compartilhando dúvidas, dicas e
          vivências para tornar nossa comunidade ainda mais acolhedora e
          enriquecedora. Seja bem-vindo!
        </div>

        <topic-categories />
      </div>

      <div class="col-lg-3 col-sm-6 order-lg-3">
        <search-form placeholder="Pesquisar tópico..." route="community" />

        <top-topics />
      </div>

      <div class="col-lg-6 order-lg-2">
        <button class="btn btn-dark d-block w-100" @click="addDialog = true">
          <i class="fas fa-plus"></i> Criar tópico
        </button>

        <action-dispatcher
          action="community/getTopics"
          :parameters="params"
          ref="topicsGet"
        >
          <div class="text-secondary text-center my-4">
            {{ count }} tópico{{ count === 1 ? "" : "s" }} encontrado{{
              count === 1 ? "" : "s"
            }}
          </div>

          <topic
            v-for="topic in topics"
            :key="topic.id"
            :topic="topic"
            link
            class="my-4"
            @edit="openEdit"
            @remove="openRemove"
          />
        </action-dispatcher>

        <pagination :count="count" :limit="params.limit" />
      </div>
    </div>

    <b-modal
      v-model="addDialog"
      hide-footer
      centered
      size="lg"
      title="Criar tópico"
    >
      <topics-form key="a" @success="refresh(true)" />
    </b-modal>

    <b-modal
      v-model="editDialog"
      hide-footer
      centered
      size="lg"
      title="Editar tópico"
    >
      <topics-form
        v-if="editDialog"
        key="b"
        @success="refresh(false)"
        :topic="selectedTopic"
      />
    </b-modal>

    <confirmation
      v-model="removeDialog"
      @confirm="remove"
      text="Tem certeza que deseja remover tópico?"
      confirm-button-text="Remover"
    />
  </div>
</template>

<script>
import Topic from "@/components/community/Topic";
import TopicsForm from "@/components/community/TopicsForm";
import SearchForm from "@/components/community/SearchForm";
import TopTopics from "@/components/community/TopTopics";
import TopicCategories from "@/components/community/TopicCategories";
import Pagination from "@/components/Pagination";
import { mapState } from "vuex";

export default {
  components: {
    TopicsForm,
    SearchForm,
    TopTopics,
    Topic,
    TopicCategories,
    Pagination
  },
  data() {
    return {
      addDialog: false,
      selectedTopic: null,
      editDialog: false,
      removeDialog: false
    };
  },
  computed: {
    currentPage() {
      return parseInt(this.$route.query.page) || 1;
    },
    params() {
      const perPage = 10;
      return {
        offset: (this.currentPage - 1) * perPage,
        limit: perPage,
        search: this.$route.query.search || "",
        category: this.$route.query.category || ""
      };
    },
    ...mapState("community", [
      "topics",
      "count",
      "likedTopics",
      "commentedTopics"
    ])
  },
  methods: {
    remove() {
      this.removeDialog = false;
      this.$store
        .dispatch("community/removeTopic", this.selectedTopic.id)
        .then(() => {
          this.$message.success("Tópico removido com sucesso");
          setTimeout(() => {
            this.refresh(false);
          }, 1999);
        })
        .catch(() => {
          this.$message.error("Erro");
        });
    },
    openEdit(topic) {
      this.editDialog = true;
      this.selectedTopic = topic;
    },
    openRemove(topic) {
      this.removeDialog = true;
      this.selectedTopic = topic;
    },
    refresh(reset = false) {
      if (reset) {
        this.$router.push({ query: { ...this.$route.query, page: 1 } });
      }
      this.addDialog = false;
      this.editDialog = false;
      this.$refs.topicsGet.dispatch();
    }
  }
};
</script>

<style lang="scss">
.view-community {
  margin-top: 13vh;
}
</style>
